import { observer } from 'mobx-react-lite';
import React from 'react';

import { Button } from '@flixbus/honeycomb-react';

import { manageGroupDataStore } from 'pages/Profile/components/ManageGroupDataModal/ManageGroupDataStore';
import { groupsStore } from 'pages/Profile/GroupsStore';

const CreateNewGroupBtn = observer(() => {
	return (
		<Button
			disabled={groupsStore.isLoading}
			onClick={() => manageGroupDataStore.activateManageGroupDataModal()}
			appearance="primary"
		>
			New group
		</Button>
	);
});

export default CreateNewGroupBtn;
